import React from 'react';
import { useTheme } from 'styled-components';
export const ArrowIcon = () => {
    const theme = useTheme();
    return (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.825 7.15845L10 10.9751L6.175 7.15845L5 8.33345L10 13.3334L15 8.33345L13.825 7.15845Z" fill={theme.colors.textBodyMain}/>
    </svg>);
};
